// extracted by mini-css-extract-plugin
export default {"companyContainer":"OM-z","companyImage":"PM-z","container":"QM-z","heading":"RM-z","darkText":"SM-z","smallHeading":"TM-z","darkBackground":"UM-z","whiteBackground":"VM-z"};